import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { FETCH_SERVIZI_OFFERTI } from '../queries/serviziOfferti';

export const fetchProcuctTypologies = async (where = {}, limit = 100) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: { where, limit },
      query: FETCH_SERVIZI_OFFERTI,
    });
    return await unmarshalGraphqlResponse(response.data, 'servizi_offertis')
      .edges;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
